import { GlobalStyles } from '@mui/material';

import React from 'react';
import { COLORS } from '../../../../utils/colors';

const CalendarGlobalStyles = () => (
  <GlobalStyles
    styles={{
      '.rbc-show-more': {
        display: 'none !important',
      },
      '.rbc-show-more:hover': {
        backgroundColor: 'transparent',
        color: COLORS.DARK_GREY,
      },
      '.calendar-container.month-view .rbc-today': {
        backgroundColor: 'transparent !important',
        border: `1px solid #19255d`,
        borderRadius: '0.3125rem',
        '&:hover': {
          backgroundColor: `${COLORS.LIGHT_GRAY} !important`,
        },
      },
      //WEEK VIEW ------------------------------
      '.calendar-container.week-view': {
        '.rbc-today': {
          backgroundColor: 'transparent !important',
          border: `2px solid ${COLORS.DARK_BLUE} !important`,
          borderRadius: '0rem',
          '.rbc-button-link': {
            fontWeight: '600',
            fontSize: '1rem !important',
          },
        },

        '.rbc-button-link': {
          fontSize: '1rem !important',
        },
        '.rbc-time-header-content': {
          height: '5rem',
        },
        '.rbc-header': {
          border: `none !important`,
          borderTop: '1px solid #ddd !important',
          borderRadius: '0rem !important',
          backgroundColor: '#fbfbfb !important',
          height: '3rem',
        },
        '.rbc-day-bg': {
          border: `none !important`,
          borderRadius: '0rem !important',
          backgroundColor: '#fbfbfb !important',
          borderBottom: '2px solid #ddd !important',
          '&:hover': {
            backgroundColor: '#fbfbfb !important',
          },
        },
        '.rbc-event': {
          backgroundColor: '#fbb873 !important',
          borderRadius: '0rem',
        },
        '.css-1knwjn7': {
          display: 'none',
        },
        '.css-yg4rxp': {
          display: 'none',
        },
        '.css-1qpvabv': {
          display: 'none',
        },
        '.rbc-day-slot .rbc-event-label': {
          paddingLeft: '0.3rem',
          fontSize: '0.625rem',
          opacity: 1,
          display: 'none',
        },
        '.rbc-day-slot .rbc-events-container': {
          marginRight: '0rem',
          '&:hover': {
            backgroundColor: `${COLORS.LIGHT_GRAY} !important`,
          },
        },
        '.rbc-time-view': {
          maxHeight: '80vh',
          borderTop: '0rem',
          borderLeft: '0rem',
        },
        '.rbc-time-header.rbc-overflowing': {
          marginRight: '0rem !important',
        },
        '.rbc-timeslot-group': {
          borderBottom: '0px',
          minHeight: '4rem',
          borderTop: '1px solid #e2e2e2',
        },
        '.rbc-time-content': {
          borderTop: '0px',
        },
        '.rbc-time-slot': {
          display: 'flex',
          alignItems: 'flex-start',
          marginTop: '-0.7rem',
          background: '#fff',
        },
      },
      //DAY VIEW --------------------------------
      '.calendar-container.day-view': {
        '.rbc-time-content> .rbc-day-slot': {
          '&:hover': {
            backgroundColor: '#fff !important',
          },
        },
        '.rbc-timeslot-group': {
          borderBottom: '0px',
          minHeight: '4rem',
          borderTop: '1px solid #e2e2e2',
        },
        '.rbc-time-slot': {
          display: 'flex',
          alignItems: 'flex-start',
          marginTop: '-0.7rem',
          background: '#fff',
        },
        '.rbc-row-content': {
          display: 'none !important',
        },
        '.rbc-time-view': {
          maxHeight: '80vh',
          borderTop: '0rem',
          borderLeft: '0rem',
        },
        '.rbc-event': {
          backgroundColor: '#fbb873 !important',
          borderRadius: '0rem',
        },
        '.css-1knwjn7': {
          display: 'none',
        },
        '.css-yg4rxp': {
          display: 'none',
        },
        '.css-1qpvabv': {
          display: 'none',
        },
        '.rbc-day-slot .rbc-event-label': {
          paddingLeft: '0.3rem',
          fontSize: '0.625rem',
          opacity: 1,
          display: 'none',
        },
        '.rbc-day-slot .rbc-events-container': {
          marginRight: '0rem',
        },
      },
      '.rbc-day-bg': {
        '&:hover': {
          backgroundColor: COLORS.LIGHT_GRAY,
        },
      },
      '.rbc-off-range-bg': {
        backgroundColor: '#fff',
        opacity: '0.4',
      },
      '.rbc-off-range-bg .rbc-event': {
        opacity: '0.4 !important',
      },
      '.rbc-off-range-bg .rbc-event-content': {
        opacity: '0.4',
      },
      '.rbc-header': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'CircularStd, sans-serif',
        fontSize: '1.1rem',
        color: '#464a53',
        width: '3.1875rem',
        height: '3.375rem',
        backgroundColor: '#fbfbfb',
        fontWeight: '200',
      },
      '.rbc-month-view': {
        borderTop: '1px solid #fbfbfb !important',
      },
      '.rbc-month-header': {
        borderTop: '1px solid #ddd !important',
      },
      '.rbc-time-content > .rbc-day-slot': {
        backgroundColor: '#fff',
        border: 'none !important',
        borderRadius: '0px !important',
        overflowX: 'none',
        '&:hover': {
          backgroundColor: '#e6e6e6',
        },
        '.rbc-time-slot': {
          borderBottom: 'none',
          backgroundColor: 'transparent',
          border: '0px',
        },
        '.rbc-day-bg': {
          border: 'none !important',
        },
        'rbc-day-slot .rbc-time-slot': {
          border: 'none !important',
        },
      },

      '.rbc-current-time-indicator': {
        backgroundColor: COLORS.MEDIUM_GRAY,
        height: '2px',
      },

      // '.rbc-row-segment': {
      //   maxWidth: '12rem !important',
      // },
    }}
  />
);
export default CalendarGlobalStyles;
